import React, { Component } from 'react';
import { connect } from 'react-redux';
import Util from '../util';
import { Toast, Picker, List } from 'antd-mobile/lib';
import {loginHXFortuneByMobile, loginHXFortuneByIdentity, getTbuxy, getTbuxyQis } from '../action/loginAction.js';
import NavigatorMain from "./NavigatorMain";
import { AlerModleTips } from './AnswerAlert'
import { hashHistory } from 'react-router';
import ModalList from "./Modal/ModalList"

class LoginHxcf extends Component{
  constructor(props) {
    super(props);
    this.state = {
      //手机号登录对应loginTypeNumber为1，身份证对应为0
      loginTypeName: '手机号码',
      loginTypeNumber: '1',
      userName: "",
      passWord: '',
      enterType:this.props.location.query.enterType ? this.props.location.query.enterType : null,
      TipsFlag:false,
      isShow:true,
      tanCar: false,
      contentVal: "",
      Bools: false
    };
    this.goCallback=false;
  }
  componentWillMount(){
    document.title = "华夏财富账号登录"
  }
  handleLogin = () => {
    if(this.state.loginTypeNumber=='1'){
      if(!this.state.userName){
        Toast.info( "请填写手机号码", 2);
        return;
      }

      let pattern = /^1[0123456789]\d{9}$/;
      if(!pattern.test(this.state.userName)){
        Toast.info( "请输入正确的手机号码", 2);
        return;
      }

      if(!this.state.passWord){
        Toast.info( "请填写登录密码", 2);
        return;
      }

      let loginParamForMobile = {
        mobileNo: this.state.userName,
        password: Util.encrypt(this.state.passWord),
      }
      Toast.loading("正在加载");
      this.props.dispatch(loginHXFortuneByMobile(loginParamForMobile, (content)=>{this.loginSuccess(content),this.setState({contentVal:content})}, (msg)=>this.loginError(msg)));
    }

    if(this.state.loginTypeNumber=='0'){
      if(!this.state.userName){
        Toast.info( "请填写证件号码", 2);
        return;
      }
      if(!this.state.passWord){
        Toast.info( "请填写登录密码", 2);
        return;
      }

      let isIDCard15 = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$/;
      let isIDCard18 = /^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x)$/;
      if(!(isIDCard15.test(this.state.userName) || isIDCard18.test(this.state.userName))){
        Toast.info( "身份证号码不符合规则，请填写正确的号码", 2);
        return;
      }

      let loginParamForIdentity = {
        accountType:  '0',
        certificateType: '0',
        certificateNo: this.state.userName.toUpperCase(),
        password: Util.encrypt(this.state.passWord),
      }
      Toast.loading("正在加载");
      this.props.dispatch(loginHXFortuneByIdentity(loginParamForIdentity, (content)=>{this.loginSuccess(content,"2"),this.setState({contentVal:content})}, (msg)=>this.loginError(msg)));
    }
  }

  loginSuccess = (content,flag) => {
    sessionStorage.setItem('loadSourceBySup', "");
    sessionStorage.setItem('loadSourceByZt', "");
    let queryEnterType = this.props.location.query ? this.props.location.query.enterType : "no";

    console.log(content,"userBindingMobil登录成功",this.props.location.query.enterType)
    if(window.navigator.userAgent.indexOf("amcfmapp")>-1) {
      if(window.navigator.userAgent.indexOf("wkwebview")>-1) {
        if(window.webkit) {
          window.webkit.messageHandlers.amcfm_utils.postMessage({"refreshHome":"intelInvest"});
        }
      }else{
        if(window.amcfm_utils) {
          window.amcfm_utils.refreshHome('intelInvest');
        }
      }
    }
    Toast.hide();
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    if(flag) {
      console.log(content,"030303003")
      if(content.userId == null && this.state.loginTypeNumber=='0') {
        console.log(content,'qw2ewqdq')

        hashHistory.push({
          pathname: "/userBindingMobile",
          state: {
            content: content,
            route: route,
            callback: callback
          }
        });
      }else {
        if(queryEnterType === "Answer" || queryEnterType === "activity"){
          if(content.isRealName){/*已实名*/
          this.props.dispatch(getTbuxy({clientType:"APP",token:""},(val)=>{
            if(val){
              if(queryEnterType === "Answer"){
                hashHistory.push({
                  pathname:'/AnswerActivityDatillPage',
                  state:{},
                  query: {enterType:"Answer",
                  activityId:this.props.location.query.activityId}
                })
              }else{
                let userId_a = content.userId ? content.userId : "";
                let tradeAccountNo_a = content.tradeAccountNo ? content.tradeAccountNo : "";
                let paramsStr = "userId=" +  userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
                console.log(paramsStr)
                let paramsData = window.encodeURIComponent(Util.aesEncrypt(paramsStr));
                window.location.href = Util.hdUrl + paramsData
              }
            }else{
              this.setState({
                tanCar: true
              })
            }
          }))
            
          }else{
            this.setState({
              TipsFlag:true
            })
          }
        }else{
          if(content.isRealName){/*已实名*/
          this.props.dispatch(getTbuxy({clientType:"APP",token:""},(val)=>{
            if(val){
              this.goCallback=true;
              // hashHistory.go(route - window.history.length);
              hashHistory.goBack();
            }else{
              this.setState({
                tanCar: true
              })
            }
          }))
          }else{
            this.goCallback=true;
            // hashHistory.go(route - window.history.length);
            hashHistory.goBack();
          }
        }
      }
    }else {
      console.log(content,"030303003")
      if(queryEnterType === "Answer" || queryEnterType === "activity"){
        if(content.isRealName){/*已实名*/
        this.props.dispatch(getTbuxy({clientType:"APP",token:""},(val)=>{
          console.log(val)
          if(val){
            if(queryEnterType === "Answer"){
              hashHistory.push({
                pathname:'/AnswerActivityDatillPage',
                state:{},
                query: {enterType:"Answer", activityId:this.props.location.query.activityId}
              })
            }else{
                let userId_a = content.userId ? content.userId : "";
                let tradeAccountNo_a = content.tradeAccountNo ? content.tradeAccountNo : "";
                let paramsStr = "userId=" +  userId_a + "&tradeAccountNo=" + tradeAccountNo_a;
                console.log(paramsStr)
                let paramsData = window.encodeURIComponent(Util.aesEncrypt(paramsStr));
                window.location.href = Util.hdUrl + paramsData
            } 
          }else{
            this.setState({
              tanCar: true
            })
          }
        }))
        }else{
          this.setState({
            TipsFlag:true
          })
        }
      }else{
        if(content.isRealName){/*已实名*/
        this.props.dispatch(getTbuxy({clientType:"APP",token:""},(val)=>{
          if(val){
            this.goCallback=true;
            // hashHistory.go(route - window.history.length);
            hashHistory.goBack();
          }else{
            this.setState({
              tanCar: true
            })
          }
        }))
        }else{
          this.goCallback=true;
          // hashHistory.go(route - window.history.length);
          hashHistory.goBack();
        }
      }
    }
  }
  componentWillUnmount(){
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    if (this.goCallback) {
      if(callback) {
        callback();
      }
    }
  }
  loginError = (msg) => {
      Toast.info( msg, 2);
  }

  goBack = () => {
    let back = this.props.location.state && this.props.location.state.back ? this.props.location.state.back : null;
    if(back) {
      back();
    }else {
      hashHistory.goBack();
    }
  }

  changeLoginType = (value) => {
    if(value[0] == "0") {
      this.setState({
        loginTypeName: "证件号码",
      });
    }else if(value[0] == "1") {
      this.setState({
        loginTypeName: "手机号码",
      });
    }
    this.setState({
      loginTypeNumber: value[0],
      userName: "",
      passWord: ""
    });
  }

  changeUserName = (event) => {
    this.setState({
      userName: event.target.value
    });
  }

  changePassWord = (event) => {
    this.setState({
      passWord: event.target.value
    });
  }

  clearUserName = () => {
    this.setState({
      userName: ""
    });
  }

  clearPassWord = () => {
    this.setState({
      passWord: ""
    });
  }

  //注册
  goRegister = () => {
    let registerParams = ''
    if(this.props.location.state.params && this.props.location.state.params.isInvestmentAdvisory){
      const EnterPage = (this.props.location.state.params.enterType == 'TargetProfitDetail' ? 'TP' : 'SP')
      registerParams = '&superFundCode='+this.props.location.state.params.fundCode+'&superFundName='+this.props.location.state.params.fundName+'&inst_id=SFH5&enterType=hxcfH5&EnterPage='+EnterPage
    }
    window.location.href = 'https://wh5.amcfortune.com/wh5-trade/#/register?clientType=hxcfH5' + registerParams
  }

  //忘记密码
  forgetPassWord = () => {
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    sessionStorage.setItem("verifyDynamicCodeSec_mobileNumber", "");
    hashHistory.push({
      pathname: "/verifyDynamicCodeSec",
      state: {
        route: route,
        callback: callback,
      },
      query:{
          enterType:this.state.enterType,
          activityId:this.props.location.query.activityId
      }
    })
  }

  closeMoadl = ()=>{
    if(this.state.Bools){
      this.props.dispatch(getTbuxyQis({clientType:"APP",token:""},()=>{
        this.setState({
          tanCar:false
        })
        if(this.state.loginTypeNumber=="1"){
          this.loginSuccess(this.state.contentVal,"")
        }else{
          this.loginSuccess(this.state.contentVal,"2")
        }
      }))
    }else{
      Toast.info("请先阅读并确认用户同步信息授权书",2);
      return
    }
	}

  goJjLogin = () => {
    console.log(this.state.enterType)
    let route = this.props.location.state && this.props.location.state.route ? this.props.location.state.route : null;
    let callback = this.props.location.state && this.props.location.state.callback ? this.props.location.state.callback : null;
    hashHistory.push({
      pathname: "/LoginHxjj",
      state: {
        route: route,
        callback: callback,
      },query:{
        enterType:this.state.enterType,
        activityId:this.props.location.query.activityId
      }
    })
  }

  async handleSure(){
    this.setState({
      TipsFlag:false
    })
    hashHistory.push({
        pathname:'/CertificationUpload',
        state:{
          phoneNo:this.state.contentVal?this.state.contentVal.mobileNo:"",
        },
        query: {enterType:this.state.enterType,
        activityId:this.props.location.query.activityId

        }
    })
  }

  render(){
    let loginTypeArr = [{
    value: "0",
    label: "身份证"
  },
  {
    value: "1",
    label: "手机号"
  }];
  let { loginTypeName, loginTypeNumber, userName, passWord,TipsFlag } = this.state;
   console.log(this.state.contentVal,"93939393993")
    return (
      <div className="mainBox"> 
        <NavigatorMain>
          <div className="boxHeader">
            <div>
              <img onClick={this.goBack} src={require("../img/leftArrow_header.png")} />
            </div>
            <div>
              <span>华夏财富账号登录</span>
            </div>
            <div>
              
            </div>
          </div>
        </NavigatorMain> 
        <div className="boxContent">
          <div style={{
              width:'auto',
              height: 45,
              marginTop: 7,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border:"1px solid #eaeded",
              position: "relative",
              display: "-webkit-flex",
              overflow: "hidden"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100}}>登录方式</span> 
           <div className="pickerBox pickerBox2" style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <Picker value={[loginTypeNumber]} title="登录方式" data={loginTypeArr} onChange={this.changeLoginType} cols={1} className="forss">
              <List.Item arrow="horizontal"></List.Item>
            </Picker> 
            {/*<img  alt="" style={{height: 40, width: 40}} src={require("../img/arrowBm.png")} />*/}
           </div>
          </div>
          <div style={{
              width:'auto',
              height: 45,
              marginTop: 7,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border:"1px solid #eaeded",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100}}>{loginTypeName}</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input id='u1' autocomplete="off" style={{WebkitFlex: 1, fontSize: 14}} onChange={this.changeUserName} value={userName} type="text"  placeholder={"请输入" + loginTypeName} /> 
            <img onClick={this.clearUserName}  alt="" style={{height: 40, width: 40, marginRight: 0}} src={require("../img/login_input_cancel.png")} />
           </div>
          </div>
          <div style={{
              width:'auto',
              height: 45,
              marginTop: 7,
              marginLeft: 13,
              marginRight: 13,
              backgroundColor: '#ffffff',
              WebkitFlexDirection: 'row',
              WebkitAlignItems: 'center',
              borderRadius: 22,
              border:"1px solid #eaeded",
              position: "relative",
              display: "-webkit-flex"
          }}>
           <span style={{paddingLeft: 13, color: "#3a3e47", fontSize: 14, width: 100}}>登录密码</span> 
           <div style={{
            display: "-webkit-flex",
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitFlex: 1
           }}>
            <input id='p1' autocomplete="off" style={{width: "100%", fontSize: 14}} onChange={this.changePassWord} value={passWord} type={this.state.isShow ?"password":"text"}  placeholder="请输入登录密码" />
            <img alt="" onClick={()=>this.setState({isShow:!this.state.isShow})} style={{height: 40, width: 40}} src={ this.state.isShow ? require('../imgs/unshow_grey@3x.png') : require('../imgs/show_grey@3x.png')}></img> 
            <img onClick={this.clearPassWord}  alt="" style={{height: 40, width: 40, marginRight: 0}} src={require("../img/login_input_cancel.png")} />
           </div>
          </div>
          <div style={{
            display: "-webkit-flex",
            paddingTop: 10,
            paddingBottom: 14,
            paddingRight: 13,
            paddingLeft: 13,
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitJustifyContent: 'center',
            marginLeft: window.winWidth-76,
            width: 76
          }}>
            <span style={{color: '#5b6370', fontSize: 11}} onClick={this.forgetPassWord}>忘记密码</span>
            
          
          </div>
          <div onClick={this.handleLogin} style={{
            marginLeft: 13,
            marginRight: 13,
            borderRadius: 20,
            backgroundColor: "#fa063a",
            height: 40,
            borderRadius: 20,
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitJustifyContent: 'center',
            display: "-webkit-flex"
          }}>
            <span style={{color: '#ffffff', fontSize: 15}}>登录</span>
          </div>
          <div onClick={this.goJjLogin} style={{
            marginLeft: 13,
            marginRight: 13,
            borderRadius: 20,
            backgroundColor: "#fff",
            height: 40,
            borderRadius: 20,
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitJustifyContent: 'center',
            display: "-webkit-flex",
            marginTop: 7,
            border: "1px solid #fa063a"
          }}>
            <span style={{color: '#fa063a', fontSize: 15}}>华夏基金账号登录</span>
          </div>
          <div onClick={this.goRegister} style={{
            marginLeft: 13,
            marginRight: 13,
            borderRadius: 20,
            backgroundColor: "#fff",
            height: 40,
            borderRadius: 20,
            WebkitFlexDirection: 'row',
            WebkitAlignItems: 'center',
            WebkitJustifyContent: 'center',
            display: "-webkit-flex",
            marginTop: 20,
            border: "1px solid #fa063a"
          }}>
            <span style={{color: '#fa063a', fontSize: 15}}>还没有账号？立即注册</span>
          </div>
        </div>
        {
          TipsFlag ? 
            <AlerModleTips content="您还未实名认证需要实名认证" handleSure={ this.handleSure.bind(this) }/> : null
        }
        <ModalList onFun={(Bools)=>{this.setState({Bools:Bools})}} flag={this.state.tanCar} btnRight={"确认"} btnRightFun={this.closeMoadl} content={"为了方便您在华夏财富系统和华夏基金系统同步办理业务，请您阅读并确认《用户同步信息授权书》"} title={""} />
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
  }
}

export default connect(mapStateToProps)(LoginHxcf);


// WEBPACK FOOTER //
// ./src/components/LoginHxcf.js